/**
 * @Description 配置相关 Vuex 模块
 */

// state
const state = {
  clientEndLogo: '',
  clientEndIco: '',
  clientEndTitle: '',
  manageEndLogo: '',
  manageEndIco: '',
  manageEndTitle: ''
}

// mutations
const mutations = {
  SET_CLIENT_END_LOGO: (state, logoUrl) => {
    state.clientEndLogo = logoUrl
  },
  SET_CLIENT_END_ICO: (state, faviconUrl) => {
    state.clientEndIco = faviconUrl
  },
  SET_CLIENT_END_TITLE: (state, tabTitle) => {
    state.clientEndTitle = tabTitle
  },
  SET_MANAGE_END_LOGO: (state, logoUrl) => {
    state.manageEndLogo = logoUrl
  },
  SET_MANAGE_END_ICO: (state, faviconUrl) => {
    state.manageEndIco = faviconUrl
  },
  SET_MANAGE_END_TITLE: (state, tabTitle) => {
    state.manageEndTitle = tabTitle
  }
}

// actions
const actions = {
  updateClientEndLogo({ commit }, logoUrl) {
    commit('SET_CLIENT_END_LOGO', logoUrl)
  },
  updateClientEndIco({ commit }, faviconUrl) {
    commit('SET_CLIENT_END_ICO', faviconUrl)
  },
  updateClientEndTitle({ commit }, tabTitle) {
    commit('SET_CLIENT_END_TITLE', tabTitle)
  },
  updateManageEndLogo({ commit }, logoUrl) {
    commit('SET_MANAGE_END_LOGO', logoUrl)
  },
  updateManageEndIco({ commit }, faviconUrl) {
    commit('SET_MANAGE_END_ICO', faviconUrl)
  },
  updateManageEndTitle({ commit }, tabTitle) {
    commit('SET_MANAGE_END_TITLE', tabTitle)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
